import React, { useRef } from 'react';
import { Card, DeviceSwitch, T } from '../fields/ui';
import PortalPage from '../PortalPage';
import useContainerWidth from '../../../hooks/useContainerWidth';

/*
 * WHAT PEOPLE SEE — the real PortalPage rendered as a visitor with the editor's in-memory data.
 * Desktop: 1280×1500 scaled to the rail width from the top-left (radius 14, a #2A2A2A ring); the
 * page scrolls inside. Mobile: 390×844 at min(1, rail/390, 640/844), radius 28, centred.
 * `forceWidth` tells the page its width so it breaks exactly like a 1280 / 390 viewport would.
 */
export default function PreviewRail({ d, device, setDevice, lists }) {
  const ref = useRef(null);
  const railW = Math.max(240, useContainerWidth(ref) || 428);
  const mobile = device === 'mobile';
  const inW = mobile ? 390 : 1280;
  const inH = mobile ? 844 : 1500;
  const scale = mobile ? Math.min(1, railW / 390, 640 / 844) : railW / 1280;
  const outW = Math.round(inW * scale);
  const outH = Math.round(inH * scale);
  return (
    <Card phone={false} style={{ padding: 16 }} data-testid="preview-card">
      <span style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
        <span style={T.title}>WHAT PEOPLE SEE</span>
        <DeviceSwitch value={device} onChange={setDevice} height={30} fontSize={9} />
      </span>
      <div ref={ref} style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div style={{ position: 'relative', width: outW, height: outH, overflow: 'hidden', borderRadius: mobile ? 28 : 14, background: '#000', boxShadow: '0 0 0 1px #2A2A2A' }} data-testid="preview-frame" data-device={device}>
          <div style={{ position: 'absolute', left: 0, top: 0, width: inW, height: inH, transform: `scale(${scale})`, transformOrigin: '0 0' }}>
            <PortalPage data={d} viewer="visitor" chrome={false} forceWidth={inW} preview guestlist={lists.going} interested={lists.interested} hosting={lists.hosting} clubs={lists.clubs} actions={PREVIEW_ACTIONS} />
          </div>
        </div>
      </div>
      <span style={{ fontSize: 10, lineHeight: 1.5, color: '#6B6B6B', textAlign: 'center' }}>{mobile ? 'Phone at 390 px, as a guest sees it.' : 'Desktop at 1280 px, as a guest sees it. Scroll inside to see more.'}</span>
    </Card>
  );
}

const noop = () => {};
const PREVIEW_ACTIONS = [
  { key: 'message', label: 'MESSAGE', variant: 'primary', onClick: noop },
  { key: 'friend', label: '+ ADD FRIEND', variant: 'secondary', onClick: noop },
  { key: 'intro', label: 'INTRODUCE', variant: 'secondary', onClick: noop },
];
